import { render, staticRenderFns } from "./family-profile.vue?vue&type=template&id=6defd1fb&scoped=true&"
import script from "./family-profile.vue?vue&type=script&lang=js&"
export * from "./family-profile.vue?vue&type=script&lang=js&"
import style0 from "./family-profile.vue?vue&type=style&index=0&id=6defd1fb&scoped=true&lang=scss&"
import style1 from "./family-profile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6defd1fb",
  null
  
)

export default component.exports